import React, { useEffect, useState } from "react";
import { IBenefitsMemberTabData } from "../../exports/interfaces";
import { marked } from "marked";
import { Fade } from "react-awesome-reveal";

const BenefitsMemberTab = (props: {
  benefitsMemberTabData: IBenefitsMemberTabData[];
}) => {
  const [activeTab, setActiveTab] = useState<string>();

  useEffect(() => {
    setActiveTab(props.benefitsMemberTabData[0]?.attributes?.Tab_Name);
  }, [props.benefitsMemberTabData]);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <section className="quality-work">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="quality-work__tab-box tabs-box">
              <ul className="tab-buttons clearfix list-unstyled">
                {props.benefitsMemberTabData.map((tabData) => (
                  <li
                    key={tabData.id}
                    className={`tab-btn ${
                      activeTab === tabData.attributes.Tab_Name
                        ? "active-btn"
                        : ""
                    }`}
                    onClick={() => handleTabChange(tabData.attributes.Tab_Name)}
                  >
                    <span>{tabData.attributes.Tab_Name}</span>
                  </li>
                ))}
              </ul>

              <div className="tabs-content">
                {props.benefitsMemberTabData.map((tabData) => {
                  const firstDescription = marked(
                    tabData.attributes.First_Description || ""
                  ) as string;
                  const secondDescription = marked(
                    tabData.attributes.Second_Description || ""
                  ) as string;
                  return (
                    activeTab === tabData.attributes.Tab_Name && (
                      <div
                        key={tabData.id}
                        className="tab active-tab animated fadeInUp"
                      >
                        <div className="tab-content__inner">
                          <div className="row">
                            <div className="col-xl-12">
                              <div className="about-one__points custom-about-one__points">
                                <Fade cascade damping={0.2} triggerOnce={true}>
                                  <h2 className="section-title__title">{tabData.attributes.First_Title}</h2>
                                  <p
                                    style={{
                                      textAlign: "justify",
                                      marginTop: "1rem",
                                    }}
                                    className="custom-margin-bottom"
                                    dangerouslySetInnerHTML={{
                                      __html: firstDescription.replace(
                                        /<li>/g,
                                        `<li><div class="icon"><span class="icon-confirmation icon" style="font-size: 21px; margin-right: 8px;"></span></div>`
                                      ),
                                    }}
                                  ></p>
                                  <h2 className="section-title__title">
                                    {tabData.attributes.Second_Title}
                                  </h2>
                                   <p
                                    style={{
                                      textAlign: "justify",
                                      marginTop: "1rem",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: secondDescription.replace(
                                        /<li>/g,
                                        `<li><div class="icon"><span class="icon-confirmation icon" style="font-size: 21px; margin-right: 8px;"></span></div>`
                                      ),
                                    }}
                                  ></p>
                                  {/* <div
                                    className="become-volunteer__btn-box"
                                    style={{ marginTop: "40px" }}
                                  >
                                    <a
                                      href={`${process.env.REACT_APP_strapiUrl}${tabData.attributes?.File?.data?.attributes?.url}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="thm-btn become-volunteer__btn"
                                    >
                                      Download the Form
                                    </a>
                                  </div> */}
                                </Fade>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsMemberTab;
